export default __webpack_public_path__ + "static/media/bulb-blue.d2b3d7e6.svg";